const COUNTRIES = {
    RU: 'RU',
}

export default COUNTRIES
